export const ACCOUNT_ENDPOINTS = {
  editSettings: "/account/ajax/edit-settings",
  deleteAccount: "/account/ajax/delete-account",
  storeSettings: "/account/ajax/store-settings",
  changeNewsletterSubscription: "/account/ajax/change-newsletter-subscription",
  changeNotificationSubscription: "/account/ajax/change-notification-subscription",
  changeMarketingSubscription: "/account/ajax/change-marketing-subscription",
  editProfile: "/account/ajax/edit-profile",
  changePassword: "/account/ajax/change-password",
  passkeys: "/account/ajax/passkeys",
  passkeyRegisterOptions: "/account/ajax/passkeys/register-options",
  passkeyRegister: "/account/ajax/passkeys/register",
  passkeyConfirmOptions: "/account/ajax/passkeys/confirm-options",
  passkeyConfirm: "/account/ajax/passkeys/confirm",
  editPayment: "/account/ajax/edit-payment",
  fetchDwollaToken: "/account/ajax/fetch-dwolla-token",
  verifyEmail: "/account/ajax/verify",
  editDesign: "/account/ajax/edit-design",
  editMockup: "/account/ajax/edit-mockup",
  editPricing: "/account/ajax/edit-pricing",
  deleteProduct: "/account/ajax/delete-product",
  changePublishingStatus: "/account/ajax/change-publishing-status",
  changeListingStatus: "/account/ajax/change-listing-status",
  changeSalesVisibleStatus: "/account/ajax/change-sales-visible-status",
  changeFeaturedStatus: "/account/ajax/change-featured-status",
  generateMockupArchive: "/account/ajax/generate-mockup-archive",
  changeDiscountActivation: "/account/ajax/change-activation-status",
  // The emailed unsubscribe link's confirm button (also the RFC 8058 one-click target).
  unsubscribe: (type, token) => `/account/unsubscribe/${encodeURIComponent(type)}/${encodeURIComponent(token)}`,
};
